// extracted by mini-css-extract-plugin
export default {"Icon":"BaseServiceIcon_Icon__MooUx","Selected":"BaseServiceIcon_Selected__pqqQV"};